var DashboardConstants = {

  INIT:         				     'init', 
  CHANGE_EVENT:   			     'changeEvent',
  GOTO_DATE:        			   'gotoDate',
  REFRESH_DATA:      				 'refreshData',
  SET_ACTIVE_TAB:    				 'setActiveTab',
  EXPAND_COLLAPSE_ROOM_TYPE: 'expandCollapseRoomType',

};

export default DashboardConstants